import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708d38c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-control-wrapper" }
const _hoisted_2 = { class: "type-list" }
const _hoisted_3 = { class: "type-wraps" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "allow-key-control" }, null, -1))
const _hoisted_5 = { class: "allow-key-control" }

import { ref, watch } from 'vue'
import { useMapStore } from '@/stores/map'
import { layerConf } from '@/utils/map.utils'
import { MAP_TYPE_ENUM } from '@/common/enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mapStore = useMapStore()

const mapType = ref(MAP_TYPE_ENUM.STAR)

watch(
  () => mapStore.tk,
  () => {
    const url =
      layerConf.filter(({ key }: any) => key === mapType.value)[0].url +
      mapStore.tk
    // 重置url
    mapStore.layerInstance.setUrl(url)
    console.error(`================= 重置 ${mapStore.tk} =================`)
  }
)

const onchange = (mapTypeId: string) => {
  const url =
    layerConf.filter(({ key }: any) => key === mapTypeId)[0].url + mapStore.tk
  // 重置url
  mapStore.layerInstance.setUrl(url)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_radio_group, {
          onChange: onchange,
          modelValue: mapType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mapType).value = $event)),
          size: "large"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layerConf), (item) => {
              return (_openBlock(), _createBlock(_component_el_radio_button, {
                key: item.key,
                label: item.key
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["map-layer allow-key-control", item.key])
                  }, [
                    _hoisted_4,
                    _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})